import { gql } from '@apollo/client';
export const USER_SETTINGS = gql`
  fragment PortalUserSettingsDTO on PortalUserSettingsDTO {
    email
    mobilePhone
    prefixMobilePhone
    landLinePhone
    prefixLandLinePhone

    habitualDirectionName
    habitualLocality
    habitualDistrict
    habitualFloor
    habitualNumber
    habitualPostalCode
    habitualCountry
    habitualDoor

    actualDirection
    actualLocality
    actualDistrict
    actualFloor
    actualDoor
    actualNumber
    actualPostalCode
    actualCountry
  }
`;